// src/providers.tsx
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Notifications } from '@mantine/notifications';
import { NotificationProvider } from './contexts/NotificationContext';
import { ToastNotificationProvider } from './components/notifications/ToastNotificationProvider';
import { CacheConfigProvider } from './contexts/cache-config-context';
import { ThemeContextProvider } from './providers/theme-provider';

// Crea una istanza globale del QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      staleTime: 1000 * 60 * 5, // 5 minuti
      gcTime: 1000 * 60 * 30, // 30 minuti (era cacheTime in v4)
    },
  },
});

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <CacheConfigProvider>
        {/* Theme Context per useTheme hook (non include MantineProvider) */}
        <ThemeContextProvider>
          {/* Mantine Notifications (Toast Provider) */}
          <Notifications />

          {/* Custom Notification System */}
          <NotificationProvider>
            <ToastNotificationProvider>
              {children}
            </ToastNotificationProvider>
          </NotificationProvider>
        </ThemeContextProvider>
      </CacheConfigProvider>
    </QueryClientProvider>
  );
}